import React from "react"
import {useSelector} from "react-redux";
import {selectCurrency} from "../../store/currencySlice";
import NumberService from "../../services/NumberService";


const AmountWithCurrency = ({amount, currencyId}) => {

    const currency = useSelector(state => selectCurrency(state, currencyId));

    const sumToDisplay = amount ? NumberService.formatSum(amount) : "0";

    return <span>{sumToDisplay}{currency && (' ' + currency.shortName)}</span>
}

export default AmountWithCurrency